import { getSupportEmail } from "@/app/lib/get-support-email";

import { ForwardTradeDisabledView } from "./forward-trade-disabled-view";

export const ForwardTradeDisabled = () => {
  const supportEmail = getSupportEmail();
  return <ForwardTradeDisabledView supportEmail={supportEmail} />;
};
